import { IconClose } from '@consta/icons/IconClose'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import type { Prettify } from '@library/types'
import type { FC, PropsWithChildren } from 'react'

import css from './ShortcutsPanel.css'

type ShortcutsContentProps = Prettify<
  PropsWithChildren & {
    closeShortcutsPanel: VoidFunction
  }
>

export const ShortcutsContent: FC<ShortcutsContentProps> = ({ children, closeShortcutsPanel }) => {
  return (
    <>
      <div className={css.header}>
        <Text view="primary" size="s" weight="medium" as="h1">
          Горячие клавиши
        </Text>
        <Button
          size="xs"
          onlyIcon={true}
          view="clear"
          iconLeft={IconClose}
          onClick={closeShortcutsPanel}
        />
      </div>
      <section className={css.terms}>{children}</section>
    </>
  )
}
